// Sistema de cache simple para optimizar las llamadas API
class APICache {
  constructor() {
    this.cache = new Map();
    this.timeouts = new Map();
    this.defaultTTL = 5 * 60 * 1000; // 5 minutos
  }

  // Generar clave única para el cache
  generateKey(endpoint, params = {}) {
    const paramString = Object.keys(params)
      .sort()
      .map(key => `${key}=${params[key]}`)
      .join('&');
    return `${endpoint}?${paramString}`;
  }

  // Obtener datos del cache
  get(key) {
    const cached = this.cache.get(key);
    if (cached && Date.now() < cached.expiry) {
      console.log('📦 Cache HIT:', key);
      return cached.data;
    }
    
    if (cached) {
      this.delete(key);
    }
    return null;
  }

  // Guardar datos en cache
  set(key, data, ttl = this.defaultTTL) {
    // Limpiar timeout anterior si existe
    if (this.timeouts.has(key)) {
      clearTimeout(this.timeouts.get(key));
    }

    // Guardar en cache
    this.cache.set(key, {
      data,
      expiry: Date.now() + ttl,
      timestamp: Date.now()
    });

    // Configurar auto-limpieza
    const timeout = setTimeout(() => {
      this.delete(key);
    }, ttl);
    
    this.timeouts.set(key, timeout);
    console.log('💾 Cache SET:', key);
  }

  // Eliminar del cache
  delete(key) {
    this.cache.delete(key);
    if (this.timeouts.has(key)) {
      clearTimeout(this.timeouts.get(key));
      this.timeouts.delete(key);
    }
  }

  // Limpiar cache completo
  clear() {
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.cache.clear();
    this.timeouts.clear();
    console.log('🧹 Cache cleared');
  }

  // Estadísticas del cache
  getStats() {
    return {
      size: this.cache.size,
      keys: Array.from(this.cache.keys()),
      totalSize: JSON.stringify([...this.cache.values()]).length
    };
  }
}

// Instancia global del cache
export const apiCache = new APICache();

// Hook personalizado para usar cache
export const useAPICache = () => {
  return {
    get: (key) => apiCache.get(key),
    set: (key, data, ttl) => apiCache.set(key, data, ttl),
    delete: (key) => apiCache.delete(key),
    clear: () => apiCache.clear(),
    stats: () => apiCache.getStats()
  };
}; 